import { apiHelper, PromiseHandler } from "../redux/apiHelper";

const getAllLabs = () =>
  PromiseHandler(apiHelper("get", "/api/admin/labs/get"));
const getLabsById = (id) =>
  PromiseHandler(apiHelper("get", `/api/admin/labs/get/${id}`));
const labsUpdate = (id, data) =>
  PromiseHandler(apiHelper("post", `/api/admin/labs/update/${id}`, data));
const addLabs = (data) =>
  PromiseHandler(apiHelper("post", `/api/admin/labs/create`, data));
const labsDeleteById = (id) =>
  PromiseHandler(apiHelper("post", `/api/admin/labs/delete/${id}`));

export { getAllLabs, getLabsById, labsUpdate, addLabs, labsDeleteById };
